import React, { useState, useContext } from 'react';
import { Query } from '@apollo/client/react/components';
import { Location } from 'history';
import ErrorPage from 'four-nets/errors/error-page';
import { hideExpiredVendorContent } from 'four-nets/vendor/permissions';
import { ViewerContext } from 'four-nets/user/viewer/viewer';

import { CoverFragment } from '../cover/cover.graphql';
import AuthorSideExpiredVendor from './author-side-expired-vendor';
import AuthorSide from './author-side';
import query, { AuthorSideLoaderQuery, AuthorSideLoaderQueryVariables } from './author-side-loader.graphql';
import { AuthorVendorFragment } from './author-vendor.graphql';

import defaultStyles from './author-side.scss';

export interface Props {
    username: string;
    location: Location<any>;
    writeMail: (to: string) => void;
    vendor?: AuthorVendorFragment;
    userBlog: CoverFragment;
}

interface State {
    groupFirst?: number;
    photoBlogsFirst?: number;
}

const AuthorSideLoader: React.FC<Props> = props => {
    const [groupFirst, setGroupFirst] = useState<number | undefined>(3);
    const [photoBlogsFirst, setPhotoBlogsFirst] = useState<number | undefined>(6);

    const { viewer } = useContext(ViewerContext);

    const onMoreGroups = () => {
        setGroupFirst(undefined);
    };

    const onMorePhotoBlogs = () => {
        setPhotoBlogsFirst(undefined);
    };

    const { username, location, writeMail, vendor, userBlog } = props;

    return hideExpiredVendorContent(vendor as AuthorVendorFragment, Boolean(viewer && viewer.username === username)) ? (
        <AuthorSideExpiredVendor username={username} />
    ) : (
        <Query<AuthorSideLoaderQuery, AuthorSideLoaderQueryVariables>
            query={query}
            variables={{ username, groupFirst, photoBlogsFirst }}
        >
            {({ error, data }) => {
                const user =
                    data &&
                    data.users &&
                    data.users.edges &&
                    data.users.edges.length &&
                    data.users.edges[0] &&
                    data.users.edges[0]!.node;
                const hasMoreGroups = user && user.groups && user.groups.pageInfo.hasNextPage;
                const hasMorePhotoBlogs = user && user.likedPhotoBlogs && user.likedPhotoBlogs.pageInfo.hasNextPage;

                return (
                    <ErrorPage error={error}>
                        {user ? (
                            <AuthorSide
                                {...user}
                                user={user}
                                userBlog={userBlog}
                                vendor={vendor}
                                writeMail={writeMail}
                                location={location}
                                onMoreGroups={hasMoreGroups ? onMoreGroups : undefined}
                                onMorePhotoBlogs={hasMorePhotoBlogs ? onMorePhotoBlogs : undefined}
                            />
                        ) : (
                            <div className={defaultStyles.authorSide} />
                        )}
                    </ErrorPage>
                );
            }}
        </Query>
    );
};

export default AuthorSideLoader;
